import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import ReduxNavigator from 'components/Navigator/ReduxNavigator'
import { APPLY_FAST_FEATURES, DASH_VIEW } from 'utils/constants'
import DashDrawer from 'components/SwitchAndGauge/DashDrawer/DashDrawer'
import AddRemoveVehicleFeaturesContainer from '../../Summary/ChecPlusVehicleSummary/AddRemoveVehicleFeatures/AddRemoveVehicleFeaturesContainer'

const SwitchAndGaugeNavigator = ({ location }) => (
  <ReduxNavigator
    render={(renderProps) => {
      if (renderProps?.id === APPLY_FAST_FEATURES) {
        return (
          <AddRemoveVehicleFeaturesContainer
            {...renderProps}
            location={location}
            showFastFeatureFilters
          />
        )
      }
      if (renderProps?.key !== DASH_VIEW) {
        return (
          <AddRemoveVehicleFeaturesContainer
            {...renderProps}
            location={location}
          />
        )
      }
      return <DashDrawer />
    }}
  />
)

SwitchAndGaugeNavigator.propTypes = {
  location: PropTypes.object.isRequired,
}

export default withRouter(SwitchAndGaugeNavigator)
